"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TwingSource {
    constructor(code, name, path = '') {
        this.code = code;
        this.name = name;
        this.path = path;
    }
    getCode() {
        return this.code;
    }
    getName() {
        return this.name;
    }
    getPath() {
        return this.path;
    }
}
exports.TwingSource = TwingSource;
